// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
/** Lazy loader for the User Settings dialog container. */ export const UserSettingsDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-usersettingsdialogcontainer" */ "./UserSettingsDialogContainer")).then((module)=>({
            default: module.UserSettingsDialogContainer
        }));
/** Lazy loading wrapper for the User Settings dialog container. */ export const LazyUserSettingsDialogContainer = /*#__PURE__*/ lazy(UserSettingsDialogContainerLazyLoader);
